import { render, staticRenderFns } from "./commodityShelves.vue?vue&type=template&id=15927d82&scoped=true"
import script from "./commodityShelves.vue?vue&type=script&lang=js"
export * from "./commodityShelves.vue?vue&type=script&lang=js"
import style0 from "./commodityShelves.vue?vue&type=style&index=0&id=15927d82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15927d82",
  null
  
)

export default component.exports